var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"hide-details":"","label":_vm.$t(`tagMappingActionRightInput.${_vm.type}.right`),"value":_vm.value,"rules":[_vm.$rules.required()]},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }